<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>        
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('PBSAR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['PBSAR']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <!--Brand-->
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  v-model="arr_FV['AGI']"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  @input="AgentGroupChangefs" />
                            </div>

                            <!--Sub Brand-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />

                            </div>

                            <!--UserID-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :cacheOptions="false"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUserId" />
                            </div>
                            
                            <!--Start Date-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.DR"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.DR.startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.DR.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>

                            <!--End Date-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.DR"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.DR.endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.DR.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>

                            <!--Status-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['RS']}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_memberpromotionstatus"
                                            :placeholder="this.utilGetDDLanguage('PM.RS')"
                                            v-model="arr_FV['RS']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <!--Promotion Code-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MTA']['PMT']}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>

                            <!--Operator-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["OP"]}} :</span>
                                <CInput size="sm" :value="arr_FV['OP']" @change="v => arr_FV['OP'] = v"></CInput>
                            </div>

                            <!--IP Address-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["IP"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" checked @click="IPAddress()" v-model="searchExactIP" id="searchExactIP" />
                                        <label class="searchLabel ml-1" for="searchExactIP">{{getLanguage["HELP"]["IPS"]}}</label>
                                    </div>
                                </div>
                                <CInput size="sm" :value="arr_FV['AIP']" @change="v => arr_FV['AIP'] = v"></CInput>
                            </div>

                            <!--System Approved-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['SA']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_memberpromotionsystemapproved"
                                            :placeholder="this.utilGetDDLanguage('PM.SA')"
                                            v-model="arr_FV['ISA']"
                                            :max-height="200" />
                            </div>

                            <!--Promotion Currency-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('PM.C')"
                                            v-model="arr_FV['CI']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <!--Promotion / Commission-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['PM']}} / {{this.getLanguage['PM']['CCP']}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_commissiontype"
                                            :placeholder="this.utilGetDDLanguage('PM.PM')"
                                            v-model="arr_FV['CT']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <!--Referral Username-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>

                            <!--Very Dangerous Person-->
                            <div class='searchCol'>
                                <label class="searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>

                            <!--Member Type-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['MTI']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_mt"
                                            :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                            v-model="searchMT" />
                            </div>

                            <!--Register Source-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>

                            <!--Free Spin Game Provider-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["FSGP"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="ddProviderListfs"
                                            :placeholder="this.utilGetDDLanguage('PM.FSGP')"
                                            v-model="arr_FV['FSGP']"
                                            :disabled="!bool_providerloaded"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <!--Convert to Currency-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>                            
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MTA']['PRS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_Psl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:5%"></td>
                            <td style="width:10%"></td>
                            <td style="width:10%"></td>
                            <td style="width:14%"></td>
                            <td style="width:10% "></td>
                            <td style="width:10%"></td>
                            <td style="width:25%"></td>
                            <td style="width:25%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:16%" :style="renderActivityStyle(1)" :class="decimal_gt >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, "USD") }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:5%">{{this.getLanguage['MTA']['C']}}</th>
                                <th style="width:10% " class="tableCtnRight">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:10%" class="tableCtnRight">{{this.getLanguage['MTA']['TPC']}}</th>
                                <th style="width:14%" class="tableCtnRight">{{this.getLanguage['MTA']['TFA']}}</th>
                                <th style="width:10% " class="tableCtnRight">{{ this.getLanguage["DLSP"]["NOS"] }}</th>
                                <th style="width:10%" class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['PM']['PMTWL']}}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TPA']}}</th>
                                <th style="width:16%" class="tableCtnRight">{{this.getLanguage['MTA']['GT']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if="arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arry_Psl">
                            <tr v-if="data.PC=='' && data.CT == 0" :style="{'background':ToggleCurrencyList.includes(data.IC)?'lightsalmon':''} ">
                                <td>{{ data.IC }} </td>
                                <td class="tableCtnRight">{{ formatNumber(data.TMC, 0) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TPC, 0) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TFA + data.TUWLA, 2, data.CS) }}</td>
                                <td class='tableCtnRight'>
                                    <span v-if="data.FS > 0" class="grid-line">
                                        {{ formatNumber(data.FS, 0) }}
                                    </span>
                                    <span v-else class="grid-line">-</span>
                                </td>
                                <td class='tableCtnRight'>
                                    <!--Spin Winning-->
                                    <span v-if="data.FSWA > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                    <span v-else class="grid-line tableCtnRight">-</span>
                                </td>
                                <td :style="renderActivityStyle(1)" :class="data.PTWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.PTWL, 2, data.CS) }}</td>
                                <td :style="[renderActivityStyle(3),{'cursor': 'pointer'},{'text-decoration': 'underline'}] " class="tableCtnRight" @click="toggleTPADisplay(data.IC)">{{ formatNumber(data.TPA, 2, data.CS) }}</td>
                                <td :style="renderActivityStyle(1)" :class="data.GTC >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.GTC, 2, data.CS) }}</td>
                            </tr>
                            <tr v-else-if="ToggleCurrencyList.includes(data.IC)">
                                <td colspan="8" :style="[{'position': 'relative'},renderActivityStyle(3)]">
                                    <span style="float: right">{{ formatNumber(data.TPA, 2, data.CS) }}</span>
                                    <span style="color: #1b1b1b; font-weight: 600; position: absolute; right: 180px">{{renderPromotionCode(data.PC, data.CT)}} :</span>
                                </td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper'>
                <header class="table-header d-flex">
                    <div class="d-flex align-items-center">
                        <strong v-if="getUserInfo.AT === 4" id="titleHeight">{{ getLanguage["SMB"]["NTWL"] }}</strong>
                        <strong v-else id="titleHeight">{{this.getLanguage['SMB']['PBSAR']}}</strong>
                        <div class="ml-2">
                            <span>
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-user theme-agent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"AG","A")}}</strong></span>
                                <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span v-if="getUserInfo.OEMI != 2" style=" border-right: solid 1px; padding-right: 5px;"><i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                        </div>
                    </div>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>                        
                    </div>
                </header>                
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TNMT"]["ORGN"]}}<i @click="setSortTable('OGN')" :class="opened.length > 0 ? setSortLogo('OGN') : ''" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MTA']['PMT']}}<i @click="setSortTable('TN')" :class="opened.length > 0 ? setSortLogo('TN') : ''" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TNMT"]["TPC"]}}<i @click="setSortTable('ISOC')" :class="opened.length > 0 ? setSortLogo('ISOC') : ''" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"]}}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage['PM']['PA']}}<i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="opened.length > 0 ? setSortLogo('PTS') : ''" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TNMT"]["ORGN"]}}<i @click="setSortTable('OGN')" :class="opened.length > 0 ? setSortLogo('OGN') : ''" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MTA']['PMT']}}<i @click="setSortTable('TN')" :class="opened.length > 0 ? setSortLogo('TN') : ''" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TNMT"]["TPC"]}}<i @click="setSortTable('ISOC')" :class="opened.length > 0 ? setSortLogo('ISOC') : ''" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"]}}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage['PM']['PA']}}<i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="opened.length > 0 ? setSortLogo('PTS') : ''" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <td colspan="100%" v-if="!is_loaded && arr_reportGroupByList.length == 0">{{this.getLanguage['GL']['PCSFR']}}</td>
                            <td colspan="100%" v-else-if="is_loaded && arr_reportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                            <template v-for="(data,index) in arr_reportGroupByList">
                                <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                    <td></td>
                                    <td><span class="grid-line">
                                        <i class="fas fa-user theme-agent" v-if="data.AL==0"></i>
                                        <i class=" " v-else :class="[data.IOL?'fa-solid fa-house theme-outlet':'fas fa-users theme-subagent']"></i>
                                        <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                        {{ data.GN }} ({{ data.GPC }})</span></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ data.TPZISOC }}</td>
                                    <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td>
                                    <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.BA, 2, data.TPZISOC, false) }}</td>
                                    <td></td>
                                </tr>
                                <tr v-for="(cdata, cindex) in arr_reportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                    <td>{{ cdata.RN }}</td>
                                    <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                    <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                    <td>
                                        <router-link :to="{ path: '/R/PR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, pc: cdata.TN, pf: parseDateToJsonString(cdata.TF), pt: parseDateToJsonString(cdata.TT), mi: searchUserId, rs: arr_FV['RS'], ri: searchReferralUserId}}" target="_blank">
                                            <div class="custom-tooltip">                                                
                                                <span>{{ cdata.TN }}</span>
                                                <span class="custom-tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                            </div>
                                        </router-link>
                                    </td>
                                    <td>{{ cdata.TPZISOC }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, cdata.TPZISOC, false) }}</td>
                                    <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constPromotionStatus, constRejectReasonP, constPromotionSystemApproved, constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))
    import $ from 'jquery'
    import draggable from 'vuedraggable';                

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {                
                bool_showSearchBar: true,
                opened: [],
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,                
                ddCurrencyList: null,
                searchCurrency: null,
                bool_isSearchCC: false,
                arr_FV: {
                    "MI": null,
                    "DR": {
                        startDate: this.getMonthStartDate(),
                        endDate: this.getMonthEndDate()
                    },
                    "RS": ["2", "4", "5", "7", "8"],
                    "PC": "",
                    "TT": 3,
                    "AGI": null,
                    "AGI_csv": null,
                    "SAGAGI": null,
                    "OP": "",
                    "AIP": "",
                    "ISA": null,
                    "CI": null,
                    "CT": null,
                    "AIP_WC": null,
                    "RI": "",                    
                    "FSGP": null
                },                
                // dropdown value
                dd_memberpromotionstatus: [],
                dd_commissiontype: [],
                dd_memberpromotionsystemapproved: [],
                dd_currency: [],
                dd_agentgroup: [],
                dd_subagentgroup: [],
                ddProviderListfs: [],
                ddDefaultSubBrand: null,
                ddMemberList: null,
                dd_mt: [], // member type                                                                               
                ddDefaultMemberList: null,
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                                
                // search fields
                searchRegisterSourceName: null,                
                searchAgi: '',                            
                searchUserId: null,                
                searchReferralUserId: null,
                searchReferralUsername: null,               
                arr_reportList: [],
                arr_reportGroupByList: [],                                
                searchExactIP: true,
                dd_referralMemberKey: 0,                
                arry_Psl: [],
                constAccessType: constAccessType,
                ML_D: false,
                is_loaded: false,                                                                                   
                rtSubBrand: 0,
                hideBrand: false,
                arry_vdp: [],
                searchVDP: null,
                searchMT: null,                                
                bool_providerloaded: false,                               
                //langViewDownline: "",                
                //showChildren: {},
                ToggleCurrencyList: []                
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionReportList();
            },            
            getVDP() {
                //Status
                this.dd_memberpromotionstatus = [{ // key1 = CTNT
                    id: "1",
                    label: this.getLanguage['DB']['AC1']//pending
                },
                {
                    id: "2",
                    label: this.getLanguage['DB']['AC2'] //AP
                },
                {
                    id: "3",
                    label: this.getLanguage['DB']['AC3']//RJ
                },
                {
                    id: "4",
                    label: this.getLanguage['DB']['AC4'] // CP
                },
                {
                    id: "5",
                    label: this.getLanguage['DB']['AC5']//C
                },
                {
                    id: "6",
                    label: this.getLanguage['DB']['AC6']//CCL
                },
                {
                    id: "7",
                    label: this.getLanguage['DB']['AC7']//SRD
                },
                {
                    id: "8",
                    label: this.getLanguage['DB']['AC8']//EP
                },
                {
                    id: "9",
                    label: this.getLanguage['DB']['AC9'] // CF
                }
                ];
                //System Approved
                this.dd_memberpromotionsystemapproved = [{
                    id: "1",
                    label: this.getLanguage['PM']['YES']
                },
                {
                    id: "0",
                    label: this.getLanguage['PM']['NO']
                }
                ];
                //Promotion / Commission
                this.dd_commissiontype = [{
                    id: "0",
                    label: this.getLanguage["PM"]["PM"]
                },
                {
                    id: "1",
                    label: this.getLanguage["PM"]["GT"]
                },
                {
                    id: "2",
                    label: this.getLanguage["PM"]["GWL"]
                }];
                //Very Dangerous Person
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.arr_FV.DR) {
                    if (this.arr_FV.DR.startDate != "") {
                        var z = this.set90daysDateSearch(this.arr_FV.DR.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                if (this.searchCurrency != null) {
                    this.bool_isSearchCC = true;
                } else {
                    this.bool_isSearchCC = false;
                }
                this.opened = [];
                this.str_tableSortBy = "";
                this.getPromotionReportList();
            },
            toggleDisplay(key) {
                //this.opened = [];
                const index = this.opened.indexOf(key);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(key)
                }
                this.resizeTableHead();
            },
            //CountItem(value) {
            //    if (this.int_IC != 1) {
            //        return value + ((this.int_IC - 1) * this.int_RC);
            //    } else {
            //        return value;
            //    }
            //},            
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                this.bool_providerloaded = false;
                this.getDataApi(`/api/dd/game/frbprovbycategory/0/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.bool_providerloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }
                            that.ddProviderListfs = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);                            
                        }
                    });

                this.getDataApi(`/api/dd/mtname`,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });

            },                                                       
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgi) {
                    agi = this.searchAgi;
                }
                // for selecting brand and filter currency (for SSA,SA,MA )
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                // for agent level and filter currency (no brand selection, for agent and sub agent level)
                var current_agi = this.getUserInfo.AGI;
                if (this.getUserInfo.AT >= 3) {
                    this.getDataApi(`/api/dd/cur/` + current_agi,
                        function (d, s) {
                            if (s) {
                                that.dd_currency = d.dropdownlist;
                            }
                        });
                }
                this.bool_providerloaded = false;
                this.getDataApi(`/api/dd/game/frbprovbycategory/` + agi + `/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.bool_providerloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }
                            that.ddProviderListfs = d.dropdownlist;
                        }
                    });
            },
            AgentGroupChangefs(value) {                
                this.arr_FV['AGI_csv'] = null;
                this.arr_FV['SAGAGI'] = null;
                this.dd_mt = [];
                var temp = "";
                if (value != undefined) {                    
                    if (value != "") {                        
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.searchAgi = temp;
                        this.arr_FV['AGI_csv'] = temp;
                        this.arr_FV['SAGAGI'] = null;                        
                    }
                    else {
                        this.searchAgi = 0;
                    }
                }
                else {
                    this.searchAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();

                var that = this;
                this.getDataApi(`/api/dd/mtname/` + temp,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.arr_FV['SAGAGI'] = agi;
                    }
                }
                else {
                    this.arr_FV['SAGAGI'] = null;
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = "";
                    if (this.arr_FV['SAGAGI']) {
                        agi = this.arr_FV['SAGAGI'];
                    } else if (this.arr_FV['AGI_csv']) {
                        agi = this.arr_FV['AGI_csv'];
                    }

                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV['AGI_csv']) {
                    parentAGI = this.arr_FV['AGI_csv'];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getPromotionReportList();
                    });
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            getPromotionReportList() {
                this.is_loaded = true;
                //this.opened = [];                              
                var that = this;                
                this.arr_reportList = [];
                this.ToggleCurrencyList = [];                
                var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var encodedSearchPromotionCode = "";
                    if (this.arr_FV['PC'] != null) {
                        encodedSearchPromotionCode = encodeURIComponent(this.arr_FV['PC'].replace(/\[/g, '[[').replace(/\]/g, ']]'));                                                
                    }

                    path += (
                        //"f.MI=" + (this.arr_FV['MI'] == null ? "" : this.arr_FV['MI']) +
                        "&f.PC=" + (encodedSearchPromotionCode) +
                        "&f.OP=" + (this.arr_FV['OP'] == null ? "" : this.arr_FV['OP']) +
                        "&f.ISA=" + (this.arr_FV['ISA'] == null ? "" : this.arr_FV['ISA']) +
                        "&f.FSGPI_in=" + (this.arr_FV['FSGP'] == null ? "" : this.arr_FV['FSGP'])
                    );

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchExactIP) {
                        if (this.arr_FV['AIP']) {
                            path += "&f.AIP=" + this.arr_FV['AIP'];
                        }
                    } else {
                        if (this.arr_FV['AIP']) {
                            path += "&f.AIP_WC=" + this.arr_FV['AIP'];
                        }
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        path += "&f.PTS_from=" + this.parseDateToJsonString(this.arr_FV.DR.startDate);
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        path += "&f.PTS_to=" + this.parseDateToJsonString(this.arr_FV.DR.endDate);
                    }                    

                    if (this.arr_FV['RS'] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.arr_FV['CT'] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CT.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CT[x];
                        }
                        path += ("&f.CT_csv=" + temp_);
                    }

                    if (this.arr_FV['SAGAGI']) {
                        path += "&f.SAGI=" + (this.arr_FV['SAGAGI'] == null ? "" : this.arr_FV['SAGAGI']);
                        path += "&f.ATAGI=" + (this.arr_FV['SAGAGI'] == null ? "" : "4-" + this.arr_FV['SAGAGI']);
                    }
                    if (this.arr_FV['AGI_csv']) {
                        path += "&f.AGI_csv=" + (this.arr_FV['AGI_csv'] == null ? "" : this.arr_FV['AGI_csv']);
                    }

                    if (this.arr_FV['CI'] != null) {
                        path += "&f.CI=" + (this.arr_FV['CI'] == null ? "" : this.arr_FV['CI']);
                        path += "&f.CI_csv=" + (this.arr_FV['CI'] == null ? "" : this.arr_FV['CI']);
                    }

                    //if (this.arr_FV['CI'] != null) {
                    //    var temp_ = "";
                    //    for (var x = 0; x < this.arr_FV.CI.length; x++) {
                    //        if (x != 0) {
                    //            temp_ += ",";
                    //        }
                    //        temp_ += this.arr_FV.CI[x];
                    //    }
                    //    path += ("&f.CI_csv=" + temp_);
                    //}

                }                                                                                               
                
                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                }
                else if (localStorage.getItem('CCUSD') != "") {                    
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchMT) {
                    path += "&f.TN=" + this.searchMT;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }               

                this.bool_fullLoading = true;

                this.getDataApi(`/api/reports/pbsar?${path}`,
                    function (d, s) {
                        if (s) {

                            if (d.R1 == null) {
                                that.arr_reportGroupByList = [];
                            } else {
                                that.arr_reportGroupByList = d.R1;
                            }
                            if (d.R2 == null) {
                                that.arr_reportList = [];
                            } else {
                                that.arr_reportList = d.R2;
                            }                           
                            that.resizeTableHead();
                        }
                        that.bool_fullLoading = false;
                    });

                this.getDataApi(`/api/mpromo/lr/total?${path}`,
                    function (data) {
                        that.setPromotionSummaryList(data);
                    });

                this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            },            
            setPromotionSummaryList(data) {
                if (!data) {
                    data = [];
                }

                this.arry_Psl = data;
                this.decimal_gt = 0;
                if (this.arry_Psl.length != 0) {
                    for (var i = 0; i < this.arry_Psl.length; i++) {
                        this.decimal_gt += this.arry_Psl[i].GT;
                    }
                }
                this.GtcurrencySyntax = 'USD';
                if (this.arry_Psl.length != 0 && (this.bool_isSearchCC || localStorage.getItem('CCUSD') != "")) {
                    this.GtcurrencySyntax = this.arry_Psl[0].CS;
                }
            },                        
            renderPromotionCode(promotionCode, commissionType) {
                if (commissionType == 1) {
                    return this.getLanguage["PM"]["TOCM"];
                }
                else if (commissionType == 2) {
                    return this.getLanguage["PM"]["WLCM"];
                }
                return promotionCode;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },           
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getTodayDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {

                this.bool_fullLoading = false;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var encodedSearchPromotionCode = "";
                    if (this.arr_FV['PC'] != null) {
                        encodedSearchPromotionCode = encodeURIComponent(this.arr_FV['PC'].replace(/\[/g, '[[').replace(/\]/g, ']]'));
                    }

                    path += (
                        "&f.PC=" + (encodedSearchPromotionCode) +
                        "&f.OP=" + (this.arr_FV['OP'] == null ? "" : this.arr_FV['OP']) +
                        "&f.ISA=" + (this.arr_FV['ISA'] == null ? "" : this.arr_FV['ISA']) +
                        "&f.FSGPI_in=" + (this.arr_FV['FSGP'] == null ? "" : this.arr_FV['FSGP'])
                    );

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchExactIP) {
                        if (this.arr_FV['AIP']) {
                            path += "&f.AIP=" + this.arr_FV['AIP'];
                        }
                    } else {
                        if (this.arr_FV['AIP']) {
                            path += "&f.AIP_WC=" + this.arr_FV['AIP'];
                        }
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        path += "&f.PTS_from=" + this.parseDateToJsonString(this.arr_FV.DR.startDate);
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        path += "&f.PTS_to=" + this.parseDateToJsonString(this.arr_FV.DR.endDate);
                    }

                    if (this.arr_FV['RS'] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.arr_FV['CT'] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CT.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CT[x];
                        }
                        path += ("&f.CT_csv=" + temp_);
                    }

                    if (this.arr_FV['SAGAGI']) {
                        path += "&f.SAGI=" + (this.arr_FV['SAGAGI'] == null ? "" : this.arr_FV['SAGAGI']);
                        path += "&f.ATAGI=" + (this.arr_FV['SAGAGI'] == null ? "" : "4-" + this.arr_FV['SAGAGI']);
                    }
                    if (this.arr_FV['AGI_csv']) {
                        path += "&f.AGI_csv=" + (this.arr_FV['AGI_csv'] == null ? "" : this.arr_FV['AGI_csv']);
                    }

                    if (this.arr_FV['CI'] != null) {
                        path += "&f.CI=" + (this.arr_FV['CI'] == null ? "" : this.arr_FV['CI']);
                        path += "&f.CI_csv=" + (this.arr_FV['CI'] == null ? "" : this.arr_FV['CI']);
                    }

                    if (this.searchCurrency) {
                        path += "&f.CICI=" + this.searchCurrency;
                    }
                    else if (localStorage.getItem('CCUSD') != "") {
                        path += "&f.CICI=" + localStorage.getItem('CCUSD');
                    }

                    if (this.searchReferralUserId) {
                        path += "&f.RI=" + this.searchReferralUserId;
                    }
                    if (this.searchVDP) {
                        path += "&f.VDP=" + this.searchVDP;
                    }
                    if (this.searchMT) {
                        path += "&f.TN=" + this.searchMT;
                    }
                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }
                }

                window.open('/api/reports/pbsarexcel?' + path, '_blank');                
            },
            IPAddress() {
                if (this.searchExactIP) {
                    this.searchExactIP = false;
                } else {
                    this.searchExactIP = true;
                }
            },
            
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            //renderClassName(header, data) {
            //    if (header == 'U') {
            //        return "kema-eft";
            //    } else if (header == 'BA' || header == 'RA' || header == 'WBB' || header == 'ATA' || header == 'PWL') {
            //        return "tableCtnRight";
            //    } else if (header == 'FS') {
            //        return "kema-eft tableCtnRight";
            //    }
            //},
            //resetColumn(headerName) {
            //    var that = this;
            //    if (that.hideBrand) {
            //        that.removeDefaultColumn('GN')
            //    }

            //    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
            //        that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
            //    }
            //    this.resizeTableHead();
            //},
            //removeColumn(headerName) {
            //    var that = this;
            //    const index = that.reportHeaders.indexOf(headerName);
            //    if (index > -1)
            //        that.reportHeaders.splice(index, 1);
            //    this.resizeTableHead();
            //},
            //removeDefaultColumn(headerName) {
            //    var that = this;
            //    const index = that.defaultReportHeaders.indexOf(headerName);
            //    if (index > -1)
            //        that.defaultReportHeaders.splice(index, 1);
            //    this.resizeTableHead();
            //},
            toggleTPADisplay(key) {
                const index = this.ToggleCurrencyList.indexOf(key);
                if (index > -1) {
                    this.ToggleCurrencyList.splice(index, 1)
                } else {
                    this.ToggleCurrencyList.push(key)
                }
            },
            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            //that.str_showDetails = (that.str_showDetails ? that.str_showDetails : that.ddCurrencyList[i].label);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
            //toggleChildren(agent) {
            //    this.$set(this.showChildren, agent.AGI, !this.showChildren[agent.AGI]);
            //},
            //getChildren(agent) {
            //    if (!agent) {
            //        return [];
            //    }
            //    else {
            //        return this.arr_reportList.filter((a) => a.OPGI === agent.AGI);
            //    }
            //},            
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS4';
            this.$parent.showActiveMenu = 'R.PBSAR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;                   
            //this.langViewDownline = this.getLanguage["WLRPT"]["VDL"];                                  
            this.loadCurrencyOptions();                        

            if (this.$route.query.ci) {
                this.arr_FV.CI = [];
                this.arr_FV.CI.push(this.$route.query.ci);
            }
            if (this.$route.query.cur) {
                this.arr_FV["CTCI"] = this.$route.query.cur;
                sessionStorage.setItem('FilterCur', this.$route.query.cur);
            } else {
                var FilterCur = sessionStorage.getItem('FilterCur');
                if (FilterCur) {
                    this.searchCurrency = FilterCur;
                    sessionStorage.removeItem('FilterCur');
                }
            }
            if (this.$route.query.pf) {
                this.arr_FV.DR.startDate = this.$route.query.pf;
            }
            if (this.$route.query.pt) {
                this.arr_FV.DR.endDate = this.$route.query.pt;
            }                       

            this.getDropdownList();
            this.getVDP();
            this.getCurrencyList();
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);            
            if (this.$route.path != this.$route.fullPath)
                this.getPromotionReportList();
        },        
        watch: {
            getLanguage() {
                this.getPromotionReportList();                
                this.getVDP();
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/PromotionBySubAgentReport.vue